'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.compress = compress;
function compress(image) {
    return new Promise(function (resolve, reject) {
        var maxSize = 1024;
        var fileName = image.name;
        var fileExtension = image.extension;
        var reader = new FileReader();
        reader.readAsDataURL(image);
        reader.onload = function (event) {
            var img = new Image();
            img.src = event.target.result;
            img.onload = function () {
                if (img.width < maxSize && img.height < maxSize) {
                    resolve(image);
                }
                var newWidth = img.width >= img.height ? maxSize : img.width * (maxSize / img.height);
                var newHeight = img.width >= img.height ? img.height * (maxSize / img.width) : maxSize;

                var elem = document.createElement('canvas');
                elem.width = newWidth;
                elem.height = newHeight;
                var ctx = elem.getContext('2d');
                ctx.drawImage(img, 0, 0, newWidth, newHeight);

                ctx.canvas.toBlob(function (blob) {
                    resolve(new File([blob], fileName, {
                        type: 'image/' + fileExtension,
                        lastModified: Date.now()
                    }));
                }, 'image/' + fileExtension, 1);
            }, reader.onerror = function (error) {
                return reject(error);
            };
        };
    });
}